module.exports = __webpack_public_path__ + "static/media/torii-gate.1172d812.svg";